
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class BillingInfoDtoModel extends Model<BillingInfoDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'string' },
		{ name: 'contactId', type: 'string' },
		{ name: 'companyName', type: 'string' },
		{ name: 'streetAddress', type: 'string' },
		{ name: 'city', type: 'string' },
		{ name: 'zipcode', type: 'string' },
		{ name: 'vatNumber', type: 'string' },
		{ name: 'glnNumber', type: 'string' },
		{ name: 'country', type: 'string' },
		{ name: 'contactFirstName', type: 'string' },
		{ name: 'contactLastName', type: 'string' },
		{ name: 'emailAddress', type: 'string' },
		{ name: 'phoneNumber', type: 'string' }
	];
	[key: string]: any;
	
	public companyId?: string;
	public contactId?: string;
	public companyName: string;
	public streetAddress: string;
	public city: string;
	public zipcode: string;
	public vatNumber: string;
	public glnNumber: string;
	public country: string;
	public contactFirstName: string;
	public contactLastName: string;
	public emailAddress: string;
	public phoneNumber: string;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.contactId = undefined;
		this.companyName = '';
		this.streetAddress = '';
		this.city = '';
		this.zipcode = '';
		this.vatNumber = '';
		this.glnNumber = '';
		this.country = '';
		this.contactFirstName = '';
		this.contactLastName = '';
		this.emailAddress = '';
		this.phoneNumber = '';
		
	}
	getProperties(){
		return BillingInfoDtoModel.classProperties;
	}
}

